export default __webpack_public_path__ + "static/media/icon-secuity.9441d83a.svg";